export default __webpack_public_path__ + "static/media/contact.cf84ed76.svg";